// Meta Pixel utility — injects pixel script and provides tracking helpers

const PIXEL_ID = '26193603199265'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export const initMetaPixel = () => {
  if (typeof window === 'undefined' || initialized) return
  if (window.fbq) {
    initialized = true
    return
  }

  // Set up the fbq stub queue
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Inject the pixel script safely (avoid relying on an existing <script> tag)
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const target =
    document.head ||
    document.getElementsByTagName('script')[0]?.parentNode ||
    document.body
  if (target) {
    target.appendChild(script)
  }

  window.fbq('init', PIXEL_ID)
  initialized = true
}

export const trackPageView = () => {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

export const trackAddToCart = (
  data: { value?: number; currency?: string; content_name?: string } = {},
) => {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', {
    value: data.value ?? 27,
    currency: data.currency ?? 'USD',
    content_name: data.content_name ?? 'DMT: La Molécula de Dios',
    content_type: 'product',
  })
}
